import React, { useState } from 'react'
import Input from './Input'
import useInputValue from '../hooks/useInputValue'
// import useData from '../hooks/useData'
import InspectUrl from './InspectUrl'
import Button from './Button'
import URL from './URL'
import ArticleResourcesContent from './ArticleResourcesContent'
import ArticleResourcesColumn from './ArticleResourcesColumn'
import { withRouter } from 'react-router-dom'
import URI from 'urijs'

const textNodesUnder = (node) => {
    var all = []
    for (node = node.firstChild; node; node = node.nextSibling) {
        if (Number(node.nodeType) === 3 && /\S/.test(node.textContent)) all.push(node)
        else all = all.concat(textNodesUnder(node))
    }
    return all
}

const Inspect = (props) => {
    const search = URI(props.location.search).search(true)
    const _url = (search && search.url) || null

    const [article_id, setArticleId] = useState(null)
    const urlField = useInputValue(_url || '')
    const [url, setUrl] = useState(_url || '')

    const addUIToPage = () => {
        const node = document.querySelector('.competitor-page-html')
        const node_array = (node && [...textNodesUnder(document.querySelector('.competitor-page-html'))]) || []
        node &&
            node_array.map((n) => {
                n.parentNode.classList.add('bg-warning')
                n.parentNode.classList.add('resource-target-text')
                return
            })
        node &&
            console.log(
                node_array.map((n) => {
                    const nodeName = (n.parentNode.nodeName !== 'A' && n.parentNode.nodeName) || n.parentNode.parentNode.nodeName
                    return { nodeName, text: n.textContent, nextSibling: n.parentNode.nextSibling, previousSibling: n.parentNode.previousSibling }
                })
            )
        node && [...document.querySelectorAll('.resource-target-text > .resource-target-text')].map((n) => n.classList.remove('resource-target-text'))

        node && console.log(document.querySelectorAll('.resource-target-text'))
    }

    return (
        <>
            <ArticleResourcesContent onArticleChange={setArticleId} article_id={article_id || undefined}>
                <div className="row">
                    <div className={'col-md-9 col-xxl-7'}>
                        <form
                            style={{ position: 'relative' }}
                            onSubmit={(e) => e.preventDefault() || setUrl(urlField.value) || props.history.push('/inspect?url=' + encodeURI(url))}
                        >
                            <div className="input-group mb-3">
                                <Input type="text" {...urlField} placeholder="Paste URL here" />
                                <div className="input-group-append">
                                    <Button className="btn-primary" onClick={() => setUrl(urlField.value)}>
                                        GRAB
                                    </Button>
                                </div>
                            </div>
                        </form>
                        {(url.length && (
                            <small>
                                <URL url={url} link={true} />
                            </small>
                        )) ||
                            null}
                        {(url.length && <InspectUrl url={url} useEffect={addUIToPage} />) || null}
                    </div>
                    <div className="col-md-3 col-xxl-5">
                        {
                            <ArticleResourcesColumn
                                grabText={true}
                                grabPage={true}
                                origin={'url'}
                                originalUrl={url}
                                displayUrl={URI(url).protocol() + '://' + URI(url).hostname()}
                            />
                        }
                    </div>
                </div>
            </ArticleResourcesContent>
        </>
    )
}

export default withRouter(Inspect)
